/**
 * Sub Nav
 */

// Vendors
import $ from 'jquery';

// toggle classes when clicked
$('[data-toggle="subnav-mobile"]').on('click', event => {
  event.preventDefault();
  $('.sub-nav .sub-nav__item')
    .not(this)
    .toggleClass('u--display-block');
});

// handle submenu of the subnav
$('.has__child .caret').on('click', event => {
  event.preventDefault();
  const subnav = $(event.currentTarget)
    .parent()
    .siblings('.sub-nav__sub');
  if (!subnav.hasClass('visible')) {
    subnav.addClass('visible');
  } else {
    subnav.removeClass('visible');
  }
});
